<template>
  <div class="loader-wrapper" :class="{ 'loader-hide': loaderHide }">
    <div class="loader-index"><span></span></div>
    <svg>
      <defs>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" stdDeviation="11" result="blur"></feGaussianBlur>
          <feColorMatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo"></feColorMatrix>
        </filter>
      </defs>
    </svg>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';

const loaderHide = ref(false);
let timeoutId: ReturnType<typeof setTimeout> | null = null;

onMounted(() => {
  timeoutId = setTimeout(() => {
    loaderHide.value = true;
    timeoutId = null;
  }, 800);
});

onBeforeUnmount(() => {
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = null;
  }
});
</script>

<style scoped>
.loader-wrapper {
  transition: opacity 0.4s ease, visibility 0.4s ease;
}
.loader-wrapper.loader-hide {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
</style>
